var map = {
	"./backoffice.de.locale.json": 1726,
	"./backoffice.el.locale.json": 2214,
	"./backoffice.en.locale.json": 8160,
	"./backoffice.fr.locale.json": 7513,
	"./base.de.locale.json": 2228,
	"./base.el.locale.json": 9222,
	"./base.en.locale.json": 9392,
	"./base.fr.locale.json": 5617,
	"./customerAnalytics.de.locale.json": 1164,
	"./customerAnalytics.el.locale.json": 2539,
	"./customerAnalytics.en.locale.json": 133,
	"./customerAnalytics.fr.locale.json": 2627,
	"./giftSelection.de.locale.json": 2778,
	"./giftSelection.el.locale.json": 5243,
	"./giftSelection.en.locale.json": 528,
	"./giftSelection.fr.locale.json": 8740,
	"./services.de.locale.json": 9353,
	"./services.el.locale.json": 496,
	"./services.en.locale.json": 9438,
	"./services.fr.locale.json": 7162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;